import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const PaymentTypeHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="payment_type" t={t}>
      <Box mb={3}>
        <H3>Nachzahlung oder Gutschrift?</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Ob Sie von Ihrem Vermieter eine Aufforderung zur Nachzahlung oder eine Gutschrift erhalten, gibt Aufschluss
          darüber, ob Ihr Vermieter einen korrekten Rechenweg zur Ermittlung der Forderungen nutzt und ob dieser
          einheitlich mit dem Mietvertrag ist.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Bei einer
          <b>Nachzahlungsforderung</b>
          übertreffen die tatsächlich angefallenen Betriebskosten die monatlich gezahlten Betriebskosten.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Bei einer
          <b>Gutschrift</b>
          sind insgesamt im Abrechnungsjahr weniger Betriebskosten angefallen, als Sie im Voraus kalkuliert wurde. Sie
          erhalten
          <b>Geld von Ihrem Vermieter</b>
          zurück.
        </Subtitle>
      </Box>
    </Trans>
  );
};
export default PaymentTypeHelp;
